/**
 * @file：拍照测肤 request
 */
import {
  SkinPicVO,
  ISkinResult,
  IResRecommendGoodThings,
  IResRecommendRecommendProduct
} from '@/schemas/skin';
import { checkResponse, checkResponseCode } from '@/utils/helpers';
import { request } from './request';
import { ApiConfigs, Response } from '../schemas/service';

const api: ApiConfigs = {
  uploadSkinPics: {
    url: 'health/api/v1/photograph/photographPicUpload',
    method: 'POST'
  },
  createSkinDetection: {
    url: '/health/api/v1/photograph/photographCreate',
    method: 'POST'
  },
  getSkinResult: {
    url: '/health/api/v1/photograph/photographResult',
    method: 'GET'
  },
  getLatelySkinResult: {
    url: '/health/api/v1/photograph/latelyPhotograph',
    method: 'GET'
  },
  queryRecommendGoodThings: {
    url: '/health/api/v1/photograph/queryRecommendGoodThings',
    method: 'GET'
  },
  queryRecommendProduct: {
    url: '/health/api/v1/photograph/queryRecommendProduct',
    method: 'GET'
  }
};

const skin = {
  async uploadSkinPics(base64s) {
    try {
      const { result, code }: Response<SkinPicVO[]> = await request(
        api.uploadSkinPics,
        undefined,
        {
          base64s
        }
      );
      if (checkResponse(code, result)) {
        return result;
      }
      return [];
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async createSkinDetection(params) {
    try {
      const { result, code }: Response<any> = await request(
        api.createSkinDetection,
        undefined,
        params
      );
      if (checkResponse(code, result)) {
        return result;
      }
      return undefined;
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async getSkinResult() {
    try {
      const { result, code }: Response<ISkinResult> = await request(
        api.getSkinResult
      );
      if (checkResponse(code, result)) {
        // TODO 排队中，赠送过期
        // result.isConsultButton = false;

        // TODO 分析中
        // result.status = 1;
        // result.index = null as any;

        return result;
      }
      return Promise.reject();
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async getLatelySkinResult() {
    try {
      const { result, code }: Response<boolean | null> = await request(
        api.getLatelySkinResult
      );
      if (checkResponseCode(code)) {
        return result;
      }
      return Promise.reject();
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async queryRecommendGoodThings({
    secondAccessSource
  }: {
    secondAccessSource?: string;
  }) {
    try {
      const {
        result
      }: Response<IResRecommendGoodThings | null> = await request(
        api.queryRecommendGoodThings,
        { secondAccessSource },
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      if (result) {
        return result;
      }
      return Promise.reject();
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async queryRecommendProduct({
    pageNum,
    pageSize = 4,
    secondAccessSource
  }: {
    pageNum: number;
    pageSize?: number;
    secondAccessSource?: string;
  }) {
    try {
      const {
        result
      }: Response<IResRecommendRecommendProduct | null> = await request(
        api.queryRecommendProduct,
        { pageNum, pageSize, secondAccessSource },
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      if (result) {
        return result;
      }
      return Promise.reject();
    } catch (err) {
      return Promise.reject(err);
    }
  }
};

export default skin;
